import { Award, Handshake, Lightbulb } from "lucide-react";

import mission from "../assets/mission.png";
import vision from "../assets/vision.png";

export default function About() {
  const values = [
    {
      icon: Lightbulb,
      title: "Innovation",
      description:
        "We stay at the forefront of technology, constantly exploring new ways to solve complex business challenges.",
    },
    {
      icon: Handshake,
      title: "Partnership",
      description:
        "We build long-term relationships with our clients, becoming trusted partners in their digital journey.",
    },
    {
      icon: Award,
      title: "Excellence",
      description:
        "We deliver exceptional quality in every project to create real business value.",
    },
  ];

  const stats = [
    { value: "50+", label: "Projects Delivered" },
    { value: "98%", label: "Client Satisfaction" },
    { value: "24/7", label: "Support Available" },
    { value: "5+", label: "Years Experience" },
  ];

  return (
    <div className="pt-28 pb-20">

      {/* HERO */}
      <section className="bg-gradient-to-r from-gray-900 to-gray-800 py-20 text-center">
        <div className="mx-auto max-w-4xl px-4">
          <h1 className="mb-6 text-4xl font-bold text-white sm:text-5xl">
            About Xstream Minds
          </h1>
          <p className="text-lg text-gray-300">
          We empower digital transformation by harnessing the power of real-time data streaming,
          cloud solutions, and AI technologies. Our mission is to help businesses innovate faster,
           operate smarter, and stay ahead in a rapidly evolving digital world.
          </p>
        </div>
      </section>

      {/* CONTENT */}
      <section className="mx-auto max-w-7xl px-4 py-20">

        {/* MISSION */}
        <div className="mb-20 grid gap-12 lg:grid-cols-2 items-center">
          <div>
            <h2 className="mb-6 text-3xl font-bold text-gray-800">
              Our Mission
            </h2>
            <p className="mb-4 text-gray-600 leading-relaxed">
            At Xstream Minds, we enable digital transformation through cutting-edge data streaming, 
            cloud, and AI technologies. We empower businesses to become more agile, data-driven,
             and innovative.
            </p>
            <p className="text-gray-600 leading-relaxed">
            Our team of passionate technologists, developers, and strategists is dedicated to solving 
      complex problems with elegant solutions.
            </p>
          </div>

          <div className="flex h-80 items-center justify-center rounded-xl bg-gray-100">
            <img
              src={mission}
              alt="Mission"
              className="h-32 w-32 object-contain"
            />
          </div>
        </div>

        {/* VISION */}
        <div className="mb-20 grid gap-12 lg:grid-cols-2 items-center">
          <div className="order-2 lg:order-1 flex h-80 items-center justify-center rounded-xl bg-gray-100">
            <img
              src={vision}
              alt="Vision"
              className="h-32 w-32 object-contain"
            />
          </div>

          <div className="order-1 lg:order-2">
            <h2 className="mb-6 text-3xl font-bold text-gray-800">
              Our Vision
            </h2>
            <p className="mb-4 text-gray-600 leading-relaxed">
              To be a global leader in real-time data and AI-driven innovation,
              helping organizations unlock competitive advantages.
            </p>
            <p className="text-gray-600 leading-relaxed">
              We envision a future where every decision is powered by
              real-time insights.
            </p>
          </div>
        </div>

        {/* VALUES */}
        <div className="mb-20">
          <h2 className="mb-12 text-center text-3xl font-bold text-gray-800">
            Our Values
          </h2>

          <div className="grid gap-8 md:grid-cols-3">
            {values.map((value) => (
              <div
                key={value.title}
                className="rounded-xl bg-white p-8 text-center shadow"
              >
                <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-orange-500">
                  <value.icon size={28} className="text-white" />
                </div>
                <h3 className="mb-3 text-xl font-semibold">
                  {value.title}
                </h3>
                <p className="text-gray-600 text-sm">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* TRUST STATS */}
        <div className="rounded-2xl bg-gray-100 p-12 text-center">
          <h2 className="mb-6 text-3xl font-bold text-gray-800">
            Why Clients Trust Xstream Minds
          </h2>
          <p className="mb-12 text-gray-500">
            We deliver results that matter.
          </p>

          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {stats.map((stat) => (
              <div key={stat.label}>
                <div className="mb-2 text-3xl font-bold text-orange-500">
                  {stat.value}
                </div>
                <p className="text-gray-600">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>

      </section>
    </div>
  );
}
